import { describeSaveFailure } from "./describeSaveFailure";
import { showGlobalToast } from "./showGlobalToast";

/**
 * Tells the user a request they started was refused: `fallback`, then the reason the API gave
 * (describeSaveFailure passes it through verbatim), in the global toast (PREC-4626).
 *
 * The toast lives on document.body. That matters where the failing mutation invalidates a parent
 * query: RTK runs `invalidatesTags` on errors too, the parent refetches, and a screen that swaps
 * its content for a loading overlay meanwhile (the list's Sources step) unmounts the form, and
 * with it any inline error. The toast outlives that remount; an inline message does not.
 */
export const toastFailure = (error: unknown, fallback: string): void =>
	showGlobalToast(describeSaveFailure(error, fallback));
